import { BadgeDataToken, ExtendedRoutes } from 'models/routes';
import { SettingsComponent } from './features/settings/settings.component';
import { CoreUiGuard } from './core/guards/core-ui.guard';
import { PartnerPortalGuard } from './core/guards/partner-portal.guard';
import { BlockingHistoryGuard } from './core/guards/blocking-history.guard';
import { AccessRequestsGuard } from './core/guards/access-requests.guard';

export const APP_ROUTES: ExtendedRoutes = [
  {
    icon: 'dashboard_customize',
    text: 'NAVBAR.PARTNER_PORTAL',
    path: 'partner-portal',
    canActivate: [PartnerPortalGuard],
    loadChildren: () => import('./features/partner-portal/partner-portal.routes')
  },
  {
    icon: 'space_dashboard',
    text: 'NAVBAR.DASHBOARD',
    path: 'dashboard',
    canActivate: [CoreUiGuard],
    loadChildren: () => import('./features/dashboard/dashboard.routes')
  },
  {
    icon: 'devices',
    text: 'NAVBAR.DEVICES',
    path: 'devices',
    canActivate: [CoreUiGuard],
    loadChildren: () => import('./features/devices/devices.routes')
  },
  {
    icon: 'manage_accounts',
    text: 'NAVBAR.PROFILES',
    path: 'profiles',
    canActivate: [CoreUiGuard],
    loadChildren: () => import('./features/profiles/profiles.routes')
  },
  {
    icon: 'history',
    text: 'NAVBAR.BLOCKING_HISTORY',
    path: 'blocking-history',
    canActivate: [CoreUiGuard, BlockingHistoryGuard],
    loadChildren: () => import('./features/blocking-history/blocking-history.routes')
  },
  {
    icon: 'error',
    text: 'NAVBAR.OPEN_REQUESTS',
    badgeData: BadgeDataToken.ACCESS_REQUEST,
    path: 'access-requests',
    canActivate: [CoreUiGuard, AccessRequestsGuard],
    loadChildren: () => import('./features/access-requests/access-requests.routes')
  },
  {
    path: 'security-check',
    icon: 'verified',
    text: 'NAVBAR.SECURITY_CHECK',
    canActivate: [CoreUiGuard],
    loadChildren: () => import('./features/security-check/security-check.routes')
  },
  {
    path: 'settings',
    component: SettingsComponent,
    hidden: true
  },
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
    hidden: true
  },
  {
    path: '**',
    redirectTo: 'dashboard',
    hidden: true
  }
];
